import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Logo from '../ui/Logo';

interface PageWelcomeModalProps {
    title: string;
    description: string;
    onStartTour: () => void;
    tourId: string;
}

const PageWelcomeModal: React.FC<PageWelcomeModalProps> = ({ title, description, onStartTour, tourId }) => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        // Check URL for auto-start trigger
        const hash = window.location.hash;
        const queryStart = hash.indexOf('?');
        const queryString = queryStart >= 0 ? hash.substring(queryStart + 1) : '';
        const params = new URLSearchParams(queryString);

        // If coming from landing page deep dive
        if (params.get('autoStartTour') === 'true') {
            // Show modal first, don't just start tour blindly
            setIsOpen(true);
        }
    }, []);

    const handleStart = () => {
        setIsOpen(false);
        onStartTour();
    };

    const handleSkip = () => {
        setIsOpen(false);
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
                    <motion.div
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.9, opacity: 0 }}
                        className="bg-premium-wood-dark border border-premium-gold/30 rounded-2xl max-w-sm w-full overflow-hidden shadow-2xl relative"
                    >
                        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-premium-wood-dark via-premium-gold to-premium-wood-dark"></div>

                        <div className="p-6 text-center relative z-10">
                            <div className="mb-4 flex justify-center">
                                <Logo variant="header" size="sm" />
                            </div>

                            <h2 className="text-xl font-serif font-bold text-white mb-2">{title}</h2>
                            <p className="text-white/70 text-sm mb-6 font-light leading-relaxed">{description}</p>

                            <div className="flex gap-3">
                                <button
                                    onClick={handleStart}
                                    className="flex-1 py-2 bg-premium-gold text-premium-wood-dark font-bold rounded-lg hover:bg-white transition-colors text-xs uppercase tracking-wider"
                                >
                                    Take Tour
                                </button>
                                <button
                                    onClick={handleSkip}
                                    className="flex-1 py-2 border border-white/10 text-white/50 hover:text-white rounded-lg transition-colors text-xs uppercase tracking-wider"
                                >
                                    Skip
                                </button>
                            </div>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default PageWelcomeModal;
